import { render, staticRenderFns } from "./UserTitleList.vue?vue&type=template&id=37aa25b1&scoped=true"
import script from "./UserTitleList.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserTitleList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UserTitleList.vue?vue&type=style&index=0&id=37aa25b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aa25b1",
  null
  
)

export default component.exports